module.exports = __webpack_public_path__ + "dist/fonts/roboto/Roboto-Light-webfont.svg";


//////////////////
// WEBPACK FOOTER
// ./dist/fonts/roboto/Roboto-Light-webfont.svg
// module id = 1630
// module chunks = 0